export default __webpack_public_path__ + "static/sa-88f3c2db412271fc0cdf6122967011ed.jpg";